import { Outlet } from "react-router-dom"
import { GoogleAnalytics } from "@/components/shared/GoogleAnalytics"
import { GA_ID } from "@/lib/appConfig"

export default function AuthLayout() {
  return (
    <>
      <GoogleAnalytics id={GA_ID} />
      <Outlet />
    </>
  )
}
